import PropTypes from 'prop-types';
import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Category from './Category';

const CategoryContainer = ({
  category,
  courses,
  destination,
  handleCategoryFocus,
  language,
  search,
  tags,
  ...props
}) => {
  const { t } = useTranslation();
  const coursesFiltered = courses.filter(
    (course) =>
      course.category === category.key &&
      (course.language === language || language === '') &&
      (course.destination === destination || destination === '') &&
      (course.tags.filter((tag) => tags.includes(tag.title)).length ||
        !tags.length),
  );
  const [isFocused, setIsFocused] = useState(false);
  const handleShowMore = useCallback(async () => {
    handleCategoryFocus();
    setIsFocused(true);
  }, [handleCategoryFocus]);
  const coursesFilteredBySearch = useMemo(
    () =>
      coursesFiltered.filter(
        (course) =>
          !search ||
          course.title.toLowerCase().includes(search.trim().toLowerCase()),
      ),
    [coursesFiltered, search],
  );
  return (
    <Category
      category={category}
      courses={coursesFilteredBySearch}
      handleShowMore={handleShowMore}
      isFocused={isFocused}
      t={t}
      {...props}
    />
  );
};

CategoryContainer.propTypes = {
  category: PropTypes.object.isRequired,
  courses: PropTypes.arrayOf(PropTypes.object).isRequired,
  destination: PropTypes.string,
  handleCategoryFocus: PropTypes.func.isRequired,
  language: PropTypes.string,
  search: PropTypes.string.isRequired,
  tags: PropTypes.arrayOf(PropTypes.string).isRequired,
};

CategoryContainer.defaultProps = {
  destination: undefined,
  language: undefined,
};

export default CategoryContainer;
